import { NextHead } from '../../head';

import { ClosedPageLayout } from './ClosedPageLayout';

export function JobDescriptionClosedPage() {
  return (
    <>
      <NextHead />
      <ClosedPageLayout title="채용 공고가 종료되었어요." />
    </>
  );
}
